export default "__VITE_ASSET__BXhvmS2v__"